import { Stack, styled } from '@mui/material';
import Button, { Props as ButtonProps } from '../../../../../components/Button';
import clsx from 'clsx';
import { generateClasses } from '../../../../../utils/helper';

export const accordionClasses = generateClasses('Accordion', ['header']);

export const Root = styled(Stack)<{ isOpen: boolean }>(({ isOpen, theme }) => ({
  gap: isOpen ? theme.spacing(3) : theme.spacing(0),
  flexGrow: isOpen ? 1 : 0,
  flexShrink: isOpen ? 1 : 0,
  transition: theme.transitions.create(['gap', 'grid-template-rows'], { duration: 300 }),
  overflow: 'hidden',
}));

export const Header = styled((props: ButtonProps) => (
  <Button
    variant="outlined"
    size="small"
    fullWidth
    {...props}
    className={clsx(accordionClasses.header, props.className)}
  />
))(({ theme }) => ({
  [`&.${accordionClasses.header}`]: {
    ...theme.typography.h6Bold,
    justifyContent: 'space-between',
    borderWidth: 0.5,
    borderRadius: 6,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
})) as typeof Button;

export const Content = styled('div')<{ isOpen: boolean }>(({ theme, isOpen }) => {
  return {
    flex: 1,
    display: 'grid',
    gridTemplateRows: isOpen ? '1fr' : '0fr',
    transition: theme.transitions.create(['grid-template-rows'], { duration: 300 }),
    overflow: 'auto',
  };
});
